import { ReactNode, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import ExploreServiceFilters, { ExploreServiceTrailDifficulty } from '../../types/ExploreServiceFilters';
import useCheckboxFilterConfig from './useCheckboxFilterConfig';

const baseDifficulties: ExploreServiceTrailDifficulty[] = ['easy', 'moderate', 'hard'];
const labels = defineMessages<ExploreServiceTrailDifficulty>({
  easy: { defaultMessage: 'Easy' },
  moderate: { defaultMessage: 'Moderate' },
  hard: { defaultMessage: 'Hard' },
  strenuous: { defaultMessage: 'Strenuous' }
});

const useDifficultyFilterConfig = (
  exploreServiceFilters: ExploreServiceFilters,
  onFiltersChange: (updatedFilters: ExploreServiceFilters) => void,
  aboutDifficultyLink: ReactNode
) => {
  const intl = useIntl();

  const difficulties = useMemo(() => [...baseDifficulties, 'strenuous' as ExploreServiceTrailDifficulty], []);

  return useCheckboxFilterConfig({
    additionalContent: aboutDifficultyLink,
    exploreServiceFilterKey: 'difficulty',
    exploreServiceFilters,
    getValueLabel: difficulty => intl.formatMessage(labels[difficulty]),
    label: intl.formatMessage({ defaultMessage: 'Difficulty' }),
    onFiltersChange,
    values: difficulties
  });
};

export const getValidDifficulties = (diffs: string[]) => {
  const validDifficulties = [...baseDifficulties, 'strenuous' as ExploreServiceTrailDifficulty];
  return diffs.filter(diff => validDifficulties.includes(diff as ExploreServiceTrailDifficulty)) as ExploreServiceTrailDifficulty[];
};

export default useDifficultyFilterConfig;
